/**
 * Is the quote a home is linked to one HubSpot no longer has? ONE rule, for the pages and the
 * functions (EST-230, Oct 2026).
 *
 * The sync marks a stored quote HubSpot no longer gives (`goneFromHubspotAt` on the quote: deleted
 * in HubSpot, or merged away into another deal) and takes the mark off when HubSpot gives it again.
 * The matching stamps a home linked to such a quote with that quote's id, `linkedDealGoneId`, and
 * takes the stamp off when the mark has cleared or the home's link has moved to a quote that is
 * not marked (functions/matchPropertiesWithDeals.js).
 *
 * ⚠️ THE STAMP COUNTS ONLY WHILE IT NAMES THE QUOTE THE HOME IS LINKED TO NOW. A home whose link
 * has moved, or gone, by any route the matching does not see, never reads as gone: a stamp that
 * outlived its link would leave a home out of a mailing for good.
 * ⚠️ The stamp is the matching's: it lags a mark by up to a day (the nightly full run; the
 * hourly run only looks at quotes synced that day). The import reads the quote's own mark.
 */

/** The home's linked quote is one HubSpot no longer has. */
export function quoteGoneFromHubspot(home) {
  if (!home || typeof home !== 'object') return false;
  const stamp = home.linkedDealGoneId;
  const link = home.linkedDealId;
  if (typeof stamp !== 'string' || stamp === '') return false;
  if (link === null || link === undefined || link === '') return false;
  return String(link) === stamp;
}

/** How many of these homes are linked to a quote HubSpot no longer has. */
export const countQuoteGone = (homes) => (Array.isArray(homes) ? homes.filter(quoteGoneFromHubspot).length : 0);

/** The sentence beside a figure that leaves them out, or that takes them in. */
export function goneWords(n, included) {
  if (!Number.isInteger(n) || n <= 0) return null;
  const them = n === 1 ? '1 whose quote HubSpot no longer has' : `${n.toLocaleString('en-GB')} whose quote HubSpot no longer has`;
  return included
    ? `Includes ${them} (deleted or merged away in HubSpot).`
    : `Leaves out ${them} (deleted or merged away in HubSpot).`;
}

/** The dashboard tile's line: it has no tick-box, so it says what its Conversions figure leaves out. Null when nothing. */
export function tileGoneWords(n) {
  if (!Number.isInteger(n) || n <= 0) return null;
  return `Conversions leave out ${n.toLocaleString('en-GB')} whose quote HubSpot no longer has.`;
}
